export const liveDataItems = ["timeline", "odpStatus", "machineStatus", "planner", "workcentreView", "maintenancesTimeline"]
export const registryItems = ["workcentres", "customers", "suppliers", "articles", "customerOrders", "odps", "smart_odp", "measureTools", "maintenances"]
export const adminItems = ["boms", "odpStatuses", "processTypes", "processStatuses", "maintenanceTypes", "maintenancePhases", "machineEvents", "userEvents", "users", "roles", "buttons", "configuration"]

export const menuLabel = {
    liveData: "liveData",
    registryData: "registryData",
    adminData: "adminData"
}